import { type CSSColor, generateColorRamps } from './color-ramps-generator';

export const generateThemeBranding = (primaryColour: string) =>
	generateColorRamps(primaryColour as CSSColor);
